import { useAtom, useSetAtom } from 'jotai';
import { useFormContext } from 'react-hook-form';
import { useCallback } from 'react';
import { EllipsisHorizontalIcon } from '@heroicons/react/24/outline';
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'next-i18next';

import { Dropdown, IconButton } from '@restworld/ui-ds-base';

import { useNoteMutation } from './use-candidate-notes-mutation';
import { editIdAtom, editModeAtom, TFormValues } from '.';

export const CandidateNotesEditDeleteAction = ({ noteId, note }: { noteId: number; note: string }) => {
  const { t } = useTranslation('common');
  const { deleteNoteMutation } = useNoteMutation();
  const setEditMode = useSetAtom(editModeAtom);
  const [editId, setEditId] = useAtom(editIdAtom);
  const { setValue } = useFormContext<TFormValues>();

  const handleClick = useCallback(() => {
    if (editId === noteId) {
      // Cancel edit mode
      setEditId(-1);
      setEditMode(false);
      setValue('note', '');
      return;
    }
    setEditMode(true);
    setEditId(noteId);
    setValue('note', note);
  }, [editId, note, noteId, setEditId, setEditMode, setValue]);

  return (
    <>
      <Dropdown
        items={[
          {
            label: editId === noteId ? t('cancel') : t('edit_comment'),
            onClick: handleClick,
            Icon: PencilSquareIcon,
          },
          {
            label: t('remove_comment'),
            onClick: () => {
              deleteNoteMutation(noteId);
            },
            Icon: TrashIcon,
            isCriticalAction: true,
          },
        ]}
        triggerElement={<IconButton ariaLabel="more" Icon={EllipsisHorizontalIcon} />}
      />
    </>
  );
};
